const KindType = Object.freeze({
  facebookPost: 'facebookPost',
  instagramPost: 'instagramPost',
  linkedinPost: 'linkedinPost',
  facebookAds: 'facebookAds',
  gmbNewsPost: 'gmbNewsPost',
  gmbProductDescription: 'gmbProductDescription',
  customerMailing: 'customerMailing',
  websiteText: 'websiteText',
  interview: 'interview'
})

export const KindTypeIcon = Object.freeze({
  facebookPost: '/img/kindTypes/facebook.png',
  instagramPost: '/img/kindTypes/instagram.png',
  linkedinPost: '/img/kindTypes/linkedin.png',
  facebookAds: '/img/kindTypes/facebook.png',
  gmbNewsPost: '/img/kindTypes/post.png',
  gmbProductDescription: '/img/kindTypes/product-description.png',
  customerMailing: '/img/kindTypes/email.png',
  websiteText: '/img/kindTypes/left-align.png',
  interview: '/img/kindTypes/interview.png',
  all: '/img/kindTypes/settings.png'
})

export const KindName = Object.freeze({
  facebookPost: 'Facebook',
  instagramPost: 'Instagram',
  linkedinPost: 'LinkedIn'
})

export default KindType
